@use "./theme/typography";
@use "./theme/colors";
@use "./theme/spacing";
@use "./theme/layers";

// sanitize.css universally enables box-sizing: border-box, corrects browser bugs, and sets reasonable defaults.
// https://github.com/csstools/sanitize.css#what-does-it-do
@import "sanitize.css";
@import "sanitize.css/forms.css";
@import "sanitize.css/typography.css";

html {
  height: stretch;
}

body {
  // Keep both declarations to support webkit + other browsers
  // https://css-tricks.com/css-fix-for-100vh-in-mobile-webkit/
  min-height: 100vh;
  min-height: -webkit-fill-available;

  @include typography.body;
  color: var(--black);
  font-family: proxima-nova, sans-serif;
  background-color: var(--gray-04);
  display: flex;
}

#root { // stylelint-disable selector-max-id
  display: flex;
  flex: 1;
}

a {
  color: var(--blue-01);
}

// Generally we use semibold (600) for emphasis in this app
b,
strong {
  font-weight: var(--semibold-weight);
}
